/** @import modules */

import { useTranslation }       from "react-i18next";

import { useParams }            from "react-router-dom";

import { useState }             from "react";

/** @import hooks */

import { qtySum }               from "../../../Hooks/QtySum";

/** @import models */

import Product                  from "../../../Models/SingleBattery";

/** @import components */

import Breadcrumbs              from "../../../Components/Layout/Header/Breadcrumbs";

import ComponentLoader          from "../../../Components/Layout/Loaders/Loader";

import SingleProductLayout      from "../../../Components/Products/Shared/Single/Layout";

import Description              from "../../../Components/Products/Shared/Single/Description";

import SingleProductData        from "../../../Components/Products/Shared/Single/SingleProductData";

import Price                    from "../../../Components/Products/Shared/Single/Price";

import Stock                    from "../../../Components/Products/Shared/Single/Stock";

import Properties               from "../../../Components/Products/Shared/Single/Properties";

import Compare                  from "../../../Components/Products/Shared/Single/Compare/Compare";

import Title                    from "../../../Components/Products/Shared/Single/Title";

import Specifications           from "../../../Components/Products/Shared/Single/Specifications";

import ActionNotification       from "../../../Components/Products/Shared/Single/ActionNotifications";

import Delivery                 from "../../../Components/Products/Shared/Single/Delivery";

import Application              from "../../../Components/Products/Batteries/Single/Application";

import Cart from "../../../Components/Products/Tyres/Single/Cart";

import NoProductsFound           from "../../../Components/Products/Shared/Catalog/NoProductsFound";

import {
    buildCategoryPath,
    extractProductIdFromProvisionalSlug,
    productMatchesCategory
}                                   from "../../../Misc/Permalinks";

import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client";

const VISUAL_MARKUP_QUERY = gql`query {

    visualMarkup {

        markupPercent

    }

}`;

const PRODUCT_TYPE = "battery";
const categoryPath = buildCategoryPath ( PRODUCT_TYPE );

const SingleBattery = ( { expectedProductType = PRODUCT_TYPE } ) => { const
    
    { t }                   = useTranslation    (),

    routeParams             = useParams         (),

    productId               = routeParams.productId || extractProductIdFromProvisionalSlug ( routeParams.slug || routeParams.parameters ),

    { loading, data }       = Product           ( productId ),

    { loading: visualMarkupLoading, data: visualMarkupData } = useQuery ( VISUAL_MARKUP_QUERY ),

    [ 
        
        cartNotification, 
        
        setCartNotification ] = useState ( [] ),

    [ compare, setCompare ] = useState ( [] ),

    product                 = data?.product?.edges?.[ 0 ]?.node,

    productNotFound         = ! loading && ! visualMarkupLoading && (

        ! productMatchesCategory ( product, PRODUCT_TYPE ) ||

        ! productMatchesCategory ( product, expectedProductType )

    ),

    /** @returns Loaded product data and components */

    LoadProduct = () => {

        if ( loading || visualMarkupLoading ) return <ComponentLoader />

        if ( ! product ) return <NoProductsFound />;

        return <SingleProductLayout data={ product }>

            <SingleProductData data={ { 

                type: product.productType,
                
                image : product.currentImage, 
                
                model : `${ product.manufacturer.name.toUpperCase () } ${ product.model }` } }>

                    <Title product={ product } />

                    <Price price={ parseFloat ( product.priceList.retail_price ).toFixed ( 2 ) } visualMarkupData={ visualMarkupData?.visualMarkup } />

                    {/* <Stock quantity={ qtySum ( product.productVendors ) } /> */}

                    <Delivery product={ product } />

                    <Properties product={ product } />

                    { cartNotification.length > 0 && 

                        <ActionNotification data={ cartNotification } /> }

                    {/* <Application product={ product } notifications={ { view: cartNotification, set: setCartNotification } } /> */}

                    <Cart product={ product } notifications={ { view: cartNotification, set: setCartNotification } } />

                    <Compare 
                    
                        productId={ product.id } 
                    
                        type={ product.productType } 
                    
                        notifications={ { view: compare, set: setCompare } } />

            </SingleProductData>

            <Specifications data={ [

                { name: t ( "manufacturer" ), value: product.manufacturer.name, style: "uppercase" },

                { name: t ( "model" ), value: product.model, style: "regular" },

                { name: t ( "voltages" ), value: `${ product.voltage } V`, style: "regular" },

                { name: t ( "currents" ), value: `${ product.current } A`, style: "regular" },

                { name: t ( "capacities" ), value: `${ product.capacity } Ah`, style: "regular" }

            ] } />

            <Description description={ product.description } />

        </SingleProductLayout>

    };

    /** @returns component */

    if ( productNotFound ) return ( <div className="container max-content-width">

        <NoProductsFound />

    </div> );

    return ( <div className="container max-content-width">

        { ! loading && product &&

        <Breadcrumbs collection={ [

            { name: t ( "batteries" ), URI: categoryPath },

            { name: product.manufacturer.name.toUpperCase (), URI: `${ categoryPath }/${

                new URLSearchParams ( { f: 12, m: product.manufacturer.name } ).toString ()

            }` },

            { name: product.model, URI: categoryPath },

        ] } type="basic" /> }

        <LoadProduct />

    </div> );

}

/** Export component */
 
export default SingleBattery;